import { Syringe } from 'mana-syringe';
/** rootMenuId */
export const ROOT_MENU_ID = Symbol('xflow-menu-root');
/** Menu UI Model Service */
export const IMenuService = Symbol('IMenuService');
/**
 * 应该实现这个扩展点来注册更多的Menu
 */
export const IMenuContribution = Syringe.defineToken('IMenuContribution');
/**  menu item type. */
export var MenuItemType;
(function (MenuItemType) {
    MenuItemType["Separator"] = "separator";
    MenuItemType["Submenu"] = "submenu";
    MenuItemType["Root"] = "root";
    MenuItemType["Leaf"] = "leaf";
})(MenuItemType || (MenuItemType = {}));
//# sourceMappingURL=interface.js.map